<template>
  <div id="date-picker-example">
    <v-checkbox v-model="landscape" hide-details label="Landscape"></v-checkbox>
    <v-date-picker full-width v-model="picker" :landscape="landscape" :reactive="reactive" color="primary" ></v-date-picker>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        picker: (this.date !== null && this.date !== undefined)? this.date : null,
        landscape: false,
        reactive: true,
        dates: ['2018-10-20']
      }
    },
    props: ['date']
  }
</script>


// WEBPACK FOOTER //
// src/layouts/sandbox/examples/datepicker.vue